import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Толщина межпанельной прокладки (мм)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: true,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "От боковых сторон...",
          min: 0,
          value: model.height,
          "onUpdate:value": ($event: any) => ((model.height) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}